import toast from '../components/toast/toast';

export default {
  /**
   * Find all store actions with `socket_` prefix and register listeners.
   * Then bind `$socket` client to to Vue.
   */
  install(Vue) {
    /* eslint-disable no-param-reassign */

    Vue.prototype.successToast = (text) => {
      toast.makeToast({ text });
    };

    Vue.prototype.errorToast = (text) => {
      toast.makeToast({
        heading: 'Error',
        icon: 'error',
        loaderBg: 'red',
        text,
      });
    };
  },
};
